import "../PageCommon.css";
import "./Service.css";

const NotFound404Page = () => {
  return (
    <div className="page__container">
      <div className="page__head">
      </div>
      <div className="page__body">
        <div className="page__label">
          <h2>404 - Not Found</h2>
        </div>
      </div>
    </div>
  );
}

export default NotFound404Page;